import { ITouchScreenCommentObserverProps } from "interfaces";
import useIntersect from "../../../../../helpers/hooks/useIntersect";
import store from "../../../../../redux/store";

const ChatObserver = ({ setScrollEnd }: ITouchScreenCommentObserverProps) => {
    const handleIntersect = ([entry]: IntersectionObserverEntry[]) => {
        const { messages, messageCount } = store.getState().chats;
        if (entry.isIntersecting && (messages === undefined || messages.length !== messageCount)) setScrollEnd(true);
    };
    const observerRef = useIntersect(handleIntersect);

    return <div id="observer" className="pl-bg-transparent pl-pt-5" ref={observerRef} />;
};

export default ChatObserver;
